import { formatNumber } from "./format-number";

export const formatPercent = (value: number | string | undefined | null): string | undefined => {
  const num = Number(value);
  if (!Number.isFinite(num)) return undefined;

  return formatNumber(Math.floor(num * 100)) + "%";
};
